var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoYellowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFE390"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.5C11.25 14.7472 11.1767 14.9889 11.0393 15.1945C10.902 15.4 10.7068 15.5602 10.4784 15.6548C10.2499 15.7495 9.99861 15.7742 9.75614 15.726C9.51366 15.6778 9.29093 15.5587 9.11612 15.3839C8.9413 15.2091 8.82225 14.9863 8.77402 14.7439C8.72579 14.5014 8.75054 14.2501 8.84515 14.0216C8.93976 13.7932 9.09998 13.598 9.30554 13.4607C9.5111 13.3233 9.75277 13.25 10 13.25C10.3315 13.25 10.6495 13.3817 10.8839 13.6161C11.1183 13.8505 11.25 14.1685 11.25 14.5ZM10 12C10.1989 12 10.3897 11.921 10.5303 11.7803C10.671 11.6397 10.75 11.4489 10.75 11.25V5C10.75 4.80109 10.671 4.61032 10.5303 4.46967C10.3897 4.32902 10.1989 4.25 10 4.25C9.80109 4.25 9.61032 4.32902 9.46967 4.46967C9.32902 4.61032 9.25 4.80109 9.25 5V11.25C9.25 11.4489 9.32902 11.6397 9.46967 11.7803C9.61032 11.921 9.80109 12 10 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoYellowIcon);
export default __webpack_public_path__ + "static/media/no_yellow_icon.4900bd6f1a752138a051f7965d06ef09.svg";
export { ForwardRef as ReactComponent };